import React, { useContext } from "react";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Button from "@mui/material/Button";
import { SiteContext } from "gatsby-frontend/src/Site";
import { SingleContext } from "gatsby-frontend/src/Page";

function AddToCart() {
	const { cartItems, setCartItems } = useContext(SiteContext);
	const { id, type, title } = useContext(SingleContext);

	return (
		<Button
			variant="contained"
			color="primary"
			className="add-to-cart"
			startIcon={<ShoppingCartIcon />}
			sx={{
				width: "100%",
			}}
			onClick={() => {
				setCartItems([...cartItems, { id, type, title }]);
			}}
		>
			Add to cart
		</Button>
	);
}

export default AddToCart;
